module.exports = __webpack_public_path__ + "img/footer.893b6763.png";